import Image from "../../../../src/components/Image";
import * as React from 'react';
export default {
  Image,
  React
};